import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

import { MAX_GPU_TIME_SLICING_REPLICAS } from '../../constants';

import { RffInput } from '@cast/shared-rff-ui';

import { Stack } from '@cast/design-system';

type GpuTimeSlicingSectionProps = {
  disabled: boolean;
  hint?: string;
};

export const GpuTimeSlicingSection = ({
  disabled,
  hint,
}: GpuTimeSlicingSectionProps) => {
  return (
    <InlineWithDescription
      description={
        <Stack gap={4}>
          <ControlWithDescription label="GPU time-slicing">
            Time-slice a single GPU into multiple virtual replicas for shared
            access.
          </ControlWithDescription>
        </Stack>
      }
      controls={
        <RffInput
          name="replicas"
          label="Replicas"
          type="number"
          min={1}
          max={MAX_GPU_TIME_SLICING_REPLICAS}
          placeholder="e.g. 4"
          disabled={disabled}
          hint={hint}
          testId="replicas-input"
        />
      }
    />
  );
};
